﻿import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';

import SingleRegistration from './SingleRegistration';
import MultipleRegistration from './MultipleRegistration';

export default class RegistrationListing extends React.Component {
    static get propTypes() {
        return {
            registrations: PropTypes.array.isRequired
        }
    }

    render() {
        return (
            <Wrapper>
                <RegistrationInfo>
                    En påbörjad ansökan behöver slutföras inom 30 dagar. Därefter måste du börja om från början.
                </RegistrationInfo>

                {this.props.registrations.map((regGroup, i) =>
                    <div key={i}>
                        {regGroup.insurances.length && Array.isArray(regGroup.insurances[0]) &&
                            regGroup.insurances.map((objInsurances, j) => (
                                objInsurances.length > 1
                                    ? <MultipleRegistration key={j} registrations={objInsurances} />
                                    : <SingleRegistration key={j} registration={objInsurances[0]} />
                            ))
                        }

                        {regGroup.insurances.length && !Array.isArray(regGroup.insurances[0]) && regGroup.insurances.length > 1 &&
                            <MultipleRegistration registrations={regGroup.insurances} />
                        }

                        {regGroup.insurances.length && !Array.isArray(regGroup.insurances[0]) && regGroup.insurances.length == 1 &&
                            <SingleRegistration registration={regGroup.insurances[0]} />
                        }
                    </div>
                )}
            </Wrapper>
        );
    }
}

// styles 

const Wrapper = styled.div`
    background-color: ${definitions.colors.blueBackground};
    color: white; 
`;

const RegistrationInfo = styled.p`
    padding-top: 5px;
    margin-top: -10px;
    
    ${mediaQuery.small(`
        margin-top: 5px;
        line-height: 1.4;
    `)}

    font-size: 18px;
    ${mediaQuery.large(`
        font-size: 16px;
    `)}

    color: white; 
`;
